module.exports = __webpack_public_path__ + "static/media/product3.8bdbe400.png";